var _module = require('../components/module');

/*
titleCase
converts the first character of every word (space separated) in the input string
to uppercase and the remaining characters of the word to lowercase
*/

_module.filter('twoLineAddress', [
    '$sce',

    function titleCase($sce) {
        return function(str) {
            return $sce.trustAsHtml((str || '').replace(/^([\w\s\d#.]*)(,)/i, '$1<br>'));
        };
    }
]);


